import NgrxAuth from '../../auth/Auth'
import { CALL_API } from '../../util/RBRestMiddleware'

export const UPDATE_CLAIM = 'UPDATE_CLAIM'

export const BANKING_INFO_LOADING = 'BANKING_INFO_LOADING'
export const BANKING_INFO_SUCCESS = 'BANKING_INFO_SUCCESS'
export const BANKING_INFO_FAILED = 'BANKING_INFO_FAILED'
export const CLEAR_CLAIM = 'CLEAR_CLAIM'

export const SUBMIT_CLAIM_LOADING = 'SUBMIT_CLAIM_LOADING'
export const SUBMIT_CLAIM_SUCCESS = 'SUBMIT_CLAIM_SUCCESS'
export const SUBMIT_CLAIM_FAILED = 'SUBMIT_CLAIM_FAILED'

export const GET_MVA_TYPES_LOADING = 'GET_MVA_TYPES_LOADING'
export const GET_MVA_TYPES_SUCCESS = 'GET_MVA_TYPES_SUCCESS'
export const GET_MVA_TYPES_FAILED = 'GET_MVA_TYPES_FAILED'

// Motor vehicle types
export const getMvaTypes = (claimObj) => {
  const { CertificateNumber, PatientId } = claimObj
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${CertificateNumber}/mvaTypes?patientId=${PatientId}`,
        prefix: 'GET_MVA_TYPES'
      }
    })
  }
}

// CLAIM
export const updateClaim = (claimObj) => {
  return {
    type: UPDATE_CLAIM,
    claimObj
  }
}

export const clearClaimExpenses = () => {
  const claimObj = {
    ExtendedHealthCareLines: [],
    DentalClaimLines: [],
    DrugClaimLines: [],
    HCSAExpenseLines: [],
    TotalAmount: 0,
    // NOTE: not sure if the following are needed
    claimExpenses: [],
    totalPaid: 0,
    totalPaidByOther: 0
  }

  return {
    type: UPDATE_CLAIM,
    claimObj
  }
}

export const clearClaim = () => {
  return {
    type: CLEAR_CLAIM
  }
}

// Submit Claim
export const fetchBanking = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/getBankingInformation`,
        prefix: 'BANKING_INFO'
      }
    })
  }
}

export const submitClaim = (submitClaimObject, onSuccess, onError) => {
  const path = `/submitaclaim/${NgrxAuth.memberId}/` + (submitClaimObject.claimSubmitType === 'photoUpload' ? 'receipt' : 'submitAClaim')
  let newSCO = { ...submitClaimObject }
  if (submitClaimObject.claimSubmitType === 'photoUpload') {
    const readFileAsDataURL = file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = event => resolve(event.target.result)
        reader.onabort = (error) => reject(error)
        reader.onerror = error => reject(error)
        reader.readAsDataURL(file)
      }).catch(error => {
        console.error({ error })
      })
    }

    return dispatch => {
      Promise.all(submitClaimObject.ImageContent.map(readFileAsDataURL)).then(urls => {
        let fileContent = urls.map((u, index) => {
          const remove = u.substring(0, u.indexOf(',') + 1)
          return { content: u.replace(remove, '') }
        })
        let files = submitClaimObject.ImageContent.map((file, index) => {
          // files need this to get type
          const type = file.name.split('.').pop()
          return {
            fileName: file.name,
            fileLength: file.size,
            fileExtension: type,
            content: fileContent[index].content
          }
        })
        newSCO = {
          benefitType: submitClaimObject.type,
          hasCob: submitClaimObject.cob.toString(),
          useHcsa: submitClaimObject.ClaimCommonInfo.PayFromHealthCareSpendingAccount.toString(),
          patientId: submitClaimObject.PatientId,
          dependentId: submitClaimObject.DependentId.toString(),
          receipts: files,
          MvaRelated: submitClaimObject.MvaRelated
        }

        dispatch({
          [CALL_API]: {
            path: path,
            query: newSCO,
            isFileUpload: false,
            method: 'post',
            prefix: 'SUBMIT_CLAIM',
            onSuccess,
            onError
          }
        })
      }).catch(error => {
        if (error) {
          onError()
        } else {
          onError()
        }
      })
    }
  } else {
    // this is for #5731 where if an HCSA was selected and it was a HSCA and the type was EHC selected, the API would not be able to convert 'Extended Health Care' to `ClaimTypeOp.ExtendedHealthCare` because of the spaces
    if (newSCO.HCSAParameters) {
      newSCO.HCSAParameters.forEach(element => {
        element.ClaimType = element.ClaimType.replace(/\s/g, '')
      })
    }

    return dispatch => {
      dispatch({
        [CALL_API]: {
          path: path,
          query: newSCO,
          isFileUpload: submitClaimObject.claimSubmitType === 'photoUpload',
          method: 'post',
          prefix: 'SUBMIT_CLAIM',
          onSuccess,
          onError
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/submitAClaimActions.js